/**
 * BulletPoint — reusable bullet point component for legal pages.
 * Renders the exact same markup as the legacy prototype bullet points.
 */

type BulletPointProps = {
  children: React.ReactNode;
};

export const BulletPoint = ({ children }: BulletPointProps) => (
  <span className="flex">
    <div className="w-[5%] max-md:w-[10%] flex justify-end p-2.5">
      <div className="h-1.5 w-1.5 bg-black rounded-full"></div>
    </div>
    <div className="w-full font-termina">{children}</div>
  </span>
);
